import { Row, Col } from 'react-bootstrap';
import { Route, Routes, useParams } from 'react-router';
import OtherCompOverviewContainer from './other-comp-overview-container';
import IndividualCompDetailsContainer from '../common/individual-comp-details-container';

const OtherCompsPage = () => {
  return (
    <div className="container">
      <Row>
        <Col md={12}>
          <Routes>
            <Route index element={<OtherCompOverviewContainer />} />
            <Route path={':compid'} element={<IndividualCompDetailsWithRouteParam />} />
          </Routes>
        </Col>
      </Row>
    </div>
  );
};

export default OtherCompsPage;

function IndividualCompDetailsWithRouteParam() {
  const { compid } = useParams<{ compid: string }>();
  return <IndividualCompDetailsContainer compID={compid} />;
}
